import { render, staticRenderFns } from "./SecondaryPane.vue?vue&type=template&id=db4da796&scoped=true&"
import script from "./SecondaryPane.vue?vue&type=script&lang=js&"
export * from "./SecondaryPane.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryPane.vue?vue&type=style&index=0&id=db4da796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4da796",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VContainer,VProgressLinear})
